import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const TotalCostChart = ({ data, unit }) => {
    const chartData = {
        labels: data.map(item => item.month),
        datasets: [
            {
                label: 'Total Costs',
                data: data.map(item => item.total),
                backgroundColor: '#800080',
                borderColor: '#800080',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: false,
                // text: 'Total Costs',
            },
            tooltip: {
                // mode: 'nearest',
                // intersect: false, 
                borderWidth: 0,
                displayColors: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: `Amount (${unit})`,
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Month',
                },
                grid: {
                    drawOnChartArea: false
                }
            },
        },
        barPercentage: 0.6,       // Default is 0.9
        categoryPercentage: 0.7,
    };

    return (
        <div style={{ height: '300px', width: '100%' }}>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default TotalCostChart;